import { useCallback, useMemo } from 'react';
import { loginRequest } from '../helper/authConfig';

export function useAuth({ instance, accounts }) {

    // Resolve the currently active MSAL account
    const activeAccount = useMemo(() => {
        const account = instance.getActiveAccount();

        if (!account && accounts.length > 0) {
            console.warn('No active account found. Using first account.');
            return accounts[0];
        }

        return account;
    }, [instance, accounts]);

    // Open MSAL login popup and set the signed-in account
    const handleLogin = useCallback(async () => {
        try {
            const loginResponse = await instance.loginPopup(loginRequest);

            if (loginResponse.account) {
                instance.setActiveAccount(loginResponse.account);

                await instance.acquireTokenSilent({
                    ...loginRequest,
                    account: loginResponse.account,
                });
            }
        } catch (err) {
            console.error('Login failed:', err);
        }
    }, [instance]);

    // Get a bearer token for API calls
    const getAccessToken = useCallback(async () => {
        if (!activeAccount) return null;

        const tokenResponse = await instance.acquireTokenSilent({
            ...loginRequest,
            account: activeAccount,
        });

        return tokenResponse.accessToken;
    }, [activeAccount, instance]);

    return {
        activeAccount,
        handleLogin,
        getAccessToken,
    };
}